import React from 'react';

const CloseMenuIcon = () => {
  return (
    <svg
      width='14'
      height='12'
      viewBox='0 0 14 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.625 10.625L7.625 5.625L12.625 0.625M5.625 10.625L0.625 5.625L5.625 0.625'
        stroke='#5C5963'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CloseMenuIcon;
